import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, CardActionArea, Typography, Grid } from '@mui/material';
import { LocalLibrary, MenuBook, SwapHoriz, PlaylistAddCheck, Warehouse, EventBusy } from '@mui/icons-material';

const TILES = [
  { label: 'Issue / Return',       desc: 'Issue copies to learners & trainers, record returns', path: '/library/loans',       Icon: SwapHoriz,        color: '#4527a0' },
  { label: 'Bulk Textbook Assign', desc: 'Assign textbooks to a whole class at year start',      path: '/library/bulk-assign', Icon: PlaylistAddCheck, color: '#512da8' },
  { label: 'Overdue Books',        desc: 'Outstanding loans past their due date',                path: '/library/overdue',     Icon: EventBusy,        color: '#c62828' },
  { label: 'Books & Copies',       desc: 'Catalog titles and their physical copies',             path: '/library/catalog',     Icon: MenuBook,         color: '#5e35b1' },
  { label: 'Storage Areas',        desc: 'Shelves / stores for archived and old books',          path: '/library/storage-areas', Icon: Warehouse,      color: '#455a64' },
];

export default function LibraryDashboard() {
  const navigate = useNavigate();
  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto', mt: 4, px: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <LocalLibrary sx={{ color: '#5e35b1', fontSize: 32 }} />
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#5e35b1' }}>Library</Typography>
      </Box>
      <Grid container spacing={2}>
        {TILES.map(t => (
          <Grid item xs={12} sm={6} md={4} key={t.path}>
            <Card elevation={3} sx={{ borderRadius: 2, height: '100%' }}>
              <CardActionArea onClick={() => navigate(t.path)} sx={{ height: '100%' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                    <t.Icon sx={{ color: t.color, fontSize: 28 }} />
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>{t.label}</Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">{t.desc}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
